module.exports = __webpack_public_path__ + "img/btg_logo.4e0ff90c.svg";